var IpcSmdPadGeneratorWithThermalPadData = require('./ipcSmdPadGeneratorWithThermalPadData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var EllipseData = require('../../../svg/ellipseData.js');
var RectangleData = require('../../../svg/rectangleData.js');
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var ComponentAttribute = require('./componentAttribute');
var IPCRules = require('../ipcRules');
var cio_config = require("cio-config");
var PadData = require('../../padData.js');
var ThermalPadstackData = require('../../../padstack/thermalPadstackData.js');

var QuadRowPackageData = function(position, angle, init) {
    var self = this;
    IpcSmdPadGeneratorWithThermalPadData.apply(this, arguments);

    //total number of pads at top and bottom sides
    this.verticalPadCount = this.value("verticalPadCount", true, cio_config.types.positive_int.validator);

    //span between leads at top and bottom sides
    //Note: the vertical span can be different from the horizontal span
    this.verticalLeadToLeadSpanMax = this.value("verticalLeadToLeadSpanMax", true);
    this.verticalLeadToLeadSpanMin = this.value("verticalLeadToLeadSpanMin", true);

    this.nonTransformedSegmentedGeometry.addTrigger(this.verticalPadCount);
    this.nonTransformedSegmentedGeometry.addTrigger(this.verticalLeadToLeadSpanMax);
    this.nonTransformedSegmentedGeometry.addTrigger(this.verticalLeadToLeadSpanMin);
};

lib_core.inherit(QuadRowPackageData, IpcSmdPadGeneratorWithThermalPadData);
lib_core.JsonParser.registerClass(QuadRowPackageData, "QuadRowPackageData");

module.exports = QuadRowPackageData;

QuadRowPackageData.prototype.setupMinMaxPtrMap = function() {
    IpcSmdPadGeneratorWithThermalPadData.prototype.setupMinMaxPtrMap.call(this);
    this.minMaxPointerMap["verticalLeadToLeadSpan"] = [this.verticalLeadToLeadSpanMin, this.verticalLeadToLeadSpanMax]; 
    this.validationMap["verticalLeadToLeadSpanMax"] = [this.verticalLeadToLeadSpanMax];
};
/**
 * Calculate pads geometry
 * @param  {boolean} absolutePositions
 * @return {array} Array of pads.
 */
QuadRowPackageData.prototype.getPads = function(absolutePositions) {
    var self = this;
    var pads = [];

    //reset component
    self.component.reset();

    //update pads for horizontal pads
    self.updateComponentCalculator(self.horizontalLeadToLeadSpanMin(), self.horizontalLeadToLeadSpanMax());

    var i, rowIdx,
        nRow1 = self.component.padsPerSide[0], //number of pads at left side
        nRow2 = self.component.padsPerSide[1], //number of pads at bottom side
        hPitch1 = self.component.C,
        vPitch1 = self.verticalPinPitch(),
        motif = self.getMotif(),
        hPadWidth = motif.getTopCopper().width(),
        hPadHeight = motif.getTopCopper().height(),
        hRx = motif.getTopCopper().rx(),
        hRy = motif.getTopCopper().ry();

    //left pads
    for (i = 0; i < nRow1; i++) {
        rowIdx = i % nRow1;

        var pad = motif.clone();
        pad.move(new lib_geometry.Coord(-0.5 * hPitch1, ((nRow1 - 1) / 2 - rowIdx) * vPitch1));

        pads.push(pad);
    }

    //update pads for vertical pads
    self.updateComponentCalculator(self.verticalLeadToLeadSpanMin(), self.verticalLeadToLeadSpanMax());
    motif = self.getMotif();

    var hPitch2 = self.component.C,
        vPitch2 = self.verticalPinPitch(),
        vPadWidth = motif.getTopCopper().width(),
        vPadHeight = motif.getTopCopper().height(),
        vRx = motif.getTopCopper().rx(),
        vRy = motif.getTopCopper().ry();

    //bottom pads
    for (i = 0; i < nRow2; i++) {
        rowIdx = i % nRow2;

        var pad = motif.clone();
        pad.rotate(90);
        pad.move(new lib_geometry.Coord((-(nRow2 - 1) / 2 + rowIdx) * vPitch2, -0.5 * hPitch2));

        pads.push(pad);
    }

    //right pads
    for (i = 0; i < nRow1; i++) {
        rowIdx = nRow1 - 1 - i % nRow1;

        var pad = motif.clone();
        pad.padstack().topCopper().width(hPadWidth);
        pad.padstack().topCopper().height(hPadHeight);
        pad.padstack().topCopper().rx(hRx);
        pad.padstack().topCopper().ry(hRy);

        pad.move(new lib_geometry.Coord(0.5 * hPitch1, ((nRow1 - 1) / 2 - rowIdx) * vPitch1));

        pads.push(pad);
    }

    //top pads
    for (i = 0; i < nRow2; i++) {
        rowIdx = nRow2 - 1 - i % nRow2;

        var pad = motif.clone();
        pad.padstack().topCopper().width(vPadWidth);
        pad.padstack().topCopper().height(vPadHeight);
        pad.padstack().topCopper().rx(vRx);
        pad.padstack().topCopper().ry(vRy);

        pad.rotate(90);
        pad.move(new lib_geometry.Coord((-(nRow2 - 1) / 2 + rowIdx) * vPitch2, 0.5 * hPitch2));

        pads.push(pad);
    }

    //thermal pad
    if(self.hasThermalPad()) {
        pads.push(self.getThermalPad(self.thermalPadLength(), self.thermalPadWidth()));
    }

    self.updatePads(pads, absolutePositions);
    return pads;
};

QuadRowPackageData.prototype.populateSilkscreenForBody = function(body, topLeftPad, silkscreen, bottomFirstPad) {
    var pathData;
    
    //pads are outside of body
    if (topLeftPad.getPos().y + topLeftPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance + IPCRules.silkscreenStrokeWidth / 2 > body.height / 2 && bottomFirstPad.getPos().x - bottomFirstPad.getTopCopper().height() / 2 - IPCRules.silkscreenClearance - IPCRules.silkscreenStrokeWidth / 2 < -body.width / 2) {
        return silkscreen;
    }

    //left first pad with clearence is outside of body
    if (topLeftPad.getPos().y + topLeftPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance + IPCRules.silkscreenStrokeWidth / 2 > body.height / 2) {
        //top-left corner
        pathData = new PathData(new lib_geometry.Coord(-body.width / 2 - IPCRules.silkscreenStrokeWidth / 2, topLeftPad.getPos().y + topLeftPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance), IPCRules.silkscreenStrokeWidth);
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(bottomFirstPad.getPos().x - bottomFirstPad.getTopCopper().height() / 2 - IPCRules.silkscreenClearance, topLeftPad.getPos().y + topLeftPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance), PathType.LINE));
    }
    //down first pad with clearence is outside of body
    else if (bottomFirstPad.getPos().x - bottomFirstPad.getTopCopper().height() / 2 - IPCRules.silkscreenClearance - IPCRules.silkscreenStrokeWidth / 2 < -body.width / 2) {
        //top-left corner
        pathData = new PathData(new lib_geometry.Coord(bottomFirstPad.getPos().x - bottomFirstPad.getTopCopper().height() / 2 - IPCRules.silkscreenClearance, body.height / 2), IPCRules.silkscreenStrokeWidth);
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(bottomFirstPad.getPos().x - bottomFirstPad.getTopCopper().height() / 2 - IPCRules.silkscreenClearance, topLeftPad.getPos().y + topLeftPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance), PathType.LINE));
    } else {
        //top-left corner
        pathData = new PathData(new lib_geometry.Coord(-body.width / 2, topLeftPad.getPos().y + topLeftPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance), IPCRules.silkscreenStrokeWidth);
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(-body.width / 2, body.height / 2), PathType.LINE));
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(bottomFirstPad.getPos().x - bottomFirstPad.getTopCopper().height() / 2 - IPCRules.silkscreenClearance, body.height / 2), PathType.LINE));
    }

    silkscreen.push(pathData);

    //top-right corner
    pathData = pathData.clone();
    pathData.flip(new lib_geometry.Line(lib_geometry.Line.VER, new lib_geometry.Coord(0, 0)));
    silkscreen.push(pathData);

    //bottom-right corner
    pathData = pathData.clone();
    pathData.flip(new lib_geometry.Line(lib_geometry.Line.HOR, new lib_geometry.Coord(0, 0)));
    silkscreen.push(pathData);

    //bottom-left corner
    pathData = pathData.clone();
    pathData.flip(new lib_geometry.Line(lib_geometry.Line.VER, new lib_geometry.Coord(0, 0)));
    silkscreen.push(pathData);
};

/**
 * Calculate silkscreen for selected component. Silkscreen is calculated from body and pads geometry.
 * @param  {array} pads Pads calculated from getPads() function.
 * @return {array} Array of silkscreen data (LineData)
 */
QuadRowPackageData.prototype.getSilkscreen = function(pads) {
    var silkscreen = [];

    //no silkscreen if there are no pads
    if(pads.length === 0) return silkscreen;

    //get body dimesnsions depending on mapping type of silkscreen to body
    var body = this.getBodyForSilkscreen();

    ////////////////////
    //   Pin Marker   //
    ////////////////////

    silkscreen.push(this.getPinOneMarker(pads[0], body));

    //////////////////////////////
    //   Component Silkscreen   //
    //////////////////////////////
    this.populateSilkscreenForBody(body, pads[0], silkscreen, pads[this.component.padsPerSide[0]]);

    return silkscreen;
};
